@if (similarScholars?.length && !_useH3forTitle) {
  <h2>Similar Scholars</h2>
}
@if (similarScholars?.length && _useH3forTitle) {
  <h3>Similar Scholars</h3>
}
@if (similarScholars?.length) {
  <ul [ngStyle]="ulStyles">
    @for (scholar of similarScholars; track scholar) {
      <li>
        <a
          [routerLink]="scholar | personUrl"
          queryParamsHandling="merge"
          [innerText]="scholar | personName: true"
        ></a>
      </li>
    }
  </ul>
}
